import {
	isProductKey,
	type PrimaryProductKey,
	type ProductKeys,
} from '../../../common/constants/product-keys';
import type { SearchStoreExperience } from '../../../common/constants/search';
import { SearchExperience } from '../../../common/constants/search-experience';

export const getRelevantProductsForUniversalFilters = (params: {
	selectedProducts: ProductKeys[];
	primaryProduct?: PrimaryProductKey;
	experience: SearchStoreExperience;
	availableProducts: ProductKeys[];
}): ProductKeys[] => {
	if (params.selectedProducts.length > 0) {
		return params.selectedProducts;
	}

	const primaryProduct = params.primaryProduct ?? '';
	const safePrimaryProduct = isProductKey(primaryProduct) ? [primaryProduct] : undefined;

	if (params.experience === SearchExperience.QUICK_FIND) {
		return safePrimaryProduct ?? params.availableProducts;
	}

	return params.availableProducts;
};
